
export default {
	name: 'e-bill-change-sms-result',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			profile: this.$store.state.profile,
		};
	},
	computed: {

	},
	watch: {},
	created() {
	},
	mounted() {},
	updated() {},
	beforeDestroy() {},
	methods: {},
};



// WEBPACK FOOTER //
// ./src/components/eBill/eBillChangeSMS/eBillChangeSMSResult.js